/*
 * @Author: Codex
 * @Date: 2026-04-19
 * @Last Modified by: Codex
 * @Last Modified time: Do not edit
 * @Description: 推荐信息流商务广告卡片
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Swiper from 'swiper/swiper-bundle.min.js';
import utils from '../../../../../utils/utils';
import { px2dpSmall } from '../../../../../utils/px2dp';
import 'swiper/swiper.less';

const innerWidth = typeof window !== 'undefined' ? window.innerWidth : 375;
const vCardWidth = typeof window !== 'undefined' && (window.innerWidth - px2dpSmall(12) * 2 - px2dpSmall(9)) / 2;

function getWidgetHeight() {
  return 259;
}

class BusinessAdsCardWidget extends Component {
  constructor(props) {
    super(props);
    this.swiper = null;
    this.containerRef = null;
    this.cardWidth = props.cardWidth || vCardWidth;
  }

  componentDidMount() {
    this.initSwiper();
  }

  componentDidUpdate(prevProps) {
    const prevAds = prevProps.dataSource && prevProps.dataSource.ads;
    const currentAds = this.props.dataSource && this.props.dataSource.ads;
    if (prevAds !== currentAds) {
      this.destroySwiper();
      this.initSwiper();
    }
  }

  componentWillUnmount() {
    this.destroySwiper();
  }

  initSwiper = () => {
    const { dataSource = {} } = this.props;
    const { ads = [] } = dataSource;
    if (!this.containerRef || !ads.length || this.swiper) {
      return;
    }

    this.swiper = new Swiper(this.containerRef, {
      preventClicks: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      speed: 500,
      loop: ads.length > 1,
      observer: true,
      observeParents: true,
      allowTouchMove: true,
      spaceBetween: 10,
      on: {
        tap: this.handleSwiperTap
      }
    });
  }

  destroySwiper = () => {
    if (this.swiper && this.swiper.destroy) {
      this.swiper.destroy(true, true);
    }
    this.swiper = null;
  }

  getPtiPrefix = () => {
    const { templateName, templatePti } = this.props;
    return templatePti || templateName || '';
  }

  handleSwiperTap = (swiper, event) => {
    const target = event && event.target;
    if (!target || !target.getAttribute) {
      return;
    }

    const jumpUrl = target.getAttribute('jumpurl');
    const index = Number(target.getAttribute('index')) || 0;
    const { dataSource = {} } = this.props;
    const { ads = [] } = dataSource;
    const item = ads[index] || {};
    this.handleAdsClick(item, index, jumpUrl);
  }

  handleAdsClick = (item, index, jumpUrl) => {
    const { pageOptions = {}, routeParams } = this.props;
    const currentJumpUrl = jumpUrl || item.href;
    if (!currentJumpUrl) {
      return;
    }

    const options = {
      sort: index + 1
    };
    const ptiOptions = {
      ptiId: `${this.getPtiPrefix()}:banner:${index + 1}`,
      ptiName: '信息流商务广告',
      bizExtra: {
        ...pageOptions,
        tab_name: '',
        tabChName: '',
        model_block: 'banner',
        aid: item.aid,
        id: item.id
      }
    };
    // utils.jumpToUrl(routeParams, currentJumpUrl, currentJumpUrl, options, -1, this.props, false, ptiOptions);
  }

  addExposureRef = (ele) => {
    const { exp } = this.props;
    if (ele && exp && exp.add) {
      exp.add({ el: ele });
    }
  }

  renderAdsItem = (item, index) => {
    const { pageOptions = {}, webpSupport, isH5PreApi } = this.props;
    const exposeId = `${this.getPtiPrefix()}:banner:${index + 1}`;
    const biz = {
      ...pageOptions,
      id: item.id,
      aid: item.aid,
      tab_name: '',
      tabChName: '',
      model_block: 'banner'
    };

    return (
      <div
        data-dot={JSON.stringify({
          id: exposeId,
          name: '信息流商务广告',
          biz: JSON.stringify(biz),
          exposekey: exposeId,
          exposekey_self: item.expose_key || ''
        })}
        ref={this.addExposureRef}
        className="swiper-slide"
        key={`ads-${index}`}
        onClick={() => this.handleAdsClick(item, index)}
        style={styles.slide}
      >
        <img
          alt=""
          aid={item.aid}
          id={item.id}
          index={index}
          jumpurl={item.href}
          src={utils.formatImgUrl(item.img, webpSupport, '', isH5PreApi)}
          style={styles.img}
        />
      </div>
    );
  }

  render() {
    const { dataSource = {} } = this.props;
    const { ads = [] } = dataSource;
    if (!ads.length) {
      return null;
    }

    return (
      <div
        ref={ref => { this.containerRef = ref; }}
        className="goods-card business-banner swiper-container"
        style={styles.container}
      >
        <div className="swiper-wrapper">
          {ads.map(this.renderAdsItem)}
        </div>
      </div>
    );
  }
}

BusinessAdsCardWidget.propTypes = {
  dataSource: PropTypes.object,
  exp: PropTypes.object,
  isH5PreApi: PropTypes.bool,
  pageOptions: PropTypes.object,
  routeParams: PropTypes.object,
  templateName: PropTypes.string,
  templatePti: PropTypes.string,
  webpSupport: PropTypes.bool
};

BusinessAdsCardWidget.defaultProps = {
  dataSource: {},
  exp: null,
  isH5PreApi: false,
  pageOptions: {},
  routeParams: {},
  templateName: '',
  templatePti: '',
  webpSupport: false
};

const styles = {
  container: {
    width: px2dpSmall(vCardWidth),
    height: getWidgetHeight(),
    borderRadius: px2dpSmall(8),
    marginBottom: px2dpSmall(9),
    overflow: 'hidden'
  },
  slide: {
    width: px2dpSmall(vCardWidth),
    height: getWidgetHeight(),
    cursor: 'pointer'
  },
  img: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }
};

export default {
  widget: BusinessAdsCardWidget,
  getWidgetHeight,
  showStyleList: false
};



// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/lib/SHCard/widgets/BusinessAdsCardWidget.js